
import {defineComponent, inject, PropType, computed} from "vue";
import { IRct } from "@/interfaces/evidence-map";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "RctListTile",
  props: {
    rct: {
      type: Object as PropType<IRct>
    },
    active: {
      type: Boolean,
      default: null
    },
    searchMode: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const active = computed(() => props.searchMode?props.active: mapStore.state.rct === props.rct)
    const onNodeClick = () => {
      mapStore.onRctClick(props.rct)
    }
    return {
      onNodeClick,
      active
    }
  }

})
